import { FORM } from "../../Constants/Endpoints";
import { ApiRequestInterceptor } from "../apiRequest";

// ✅ date opcional (YYYY-MM-DD): si se manda, el backend regresa solo los
// formularios de ese día + totales de semana/mes ya calculados, en vez de
// la tabla completa (ver getForms.mjs en el Lambda).
export const fetchGetForms = async (date) => {
  const method = "GET";

  // 🔑 saca token del localStorage (como en login)
  const stored = JSON.parse(localStorage.getItem("logindata") || "{}");
  const token = stored?.data?.token || "";

  if (!token) {
    throw new Error("No hay token. Inicia sesión.");
  }

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const path = date ? `${FORM.getForms}?date=${encodeURIComponent(date)}` : FORM.getForms;

  const response = await ApiRequestInterceptor(path, method, null, headers);

  if (response.code === 200) {
    return response; // { items, count, ... } o { items, count, totals, datesWithForms } si mandaste date
  } else {
    const errorMessage = response?.data?.error || "Error desconocido";
    throw new Error(errorMessage);
  }
};